import React from 'react';

interface PropertyDescriptionProps {
	description: any,
	addressText: any,
	property: any
}

const PropertyDescription = ({description, addressText, property}: PropertyDescriptionProps) => {
	return (
		<article className="row g-0 fw-light">
			<h2 className="font--md cc-font-weight--bold w-100 mb-1 h6">Description for {addressText}:</h2>
			<p>
				{description ? description : (
					<span>No description included for this property.</span>
				)}
			</p>
		</article>
	);
};

export default PropertyDescription;
